// JS redifige template collection

$(document).ready(function(){
    // variables
    const ref = document.location.href
    let template_self
    let template_self_2

    // acciones
    $('body').on('change', '.js-filter-num__action', function(event) {
        event.preventDefault()
        filterNum($(this))
    })

    // funciones
    function filterNum(action) {
        if ( action.data('filter-num__collection') ) {
            template_self = ref.split('&view=')

            if (template_self != null) {
                if (action.val() == '0') {
                    window.location = `${template_self[0]}`
                }else{
                    window.location = `${template_self[0]}&view=${action.val()}`
                }
            }
        }else{
            template_self = ref.split('?view=')

            if (template_self != null) {
                if (action.val() == '0') {
                    template_self_2 = ref.split('?page=')
                    if (template_self_2[1] != null) {
                        window.location = `${template_self_2[0]}?page=${template_self_2[1].substr(0,1)}`
                    }else{
                        window.location = `${template_self[0]}`
                    }
                }else{
                    template_self_2 = ref.split('?page=')
                    if (template_self_2[1] != null) {
                        window.location = `${template_self_2[0]}?page=${template_self_2[1].substr(0,1)}&view=${action.val()}`
                    }else{
                        window.location = `${template_self[0]}?view=${action.val()}`
                    }
                }
            }else{
                window.location = `${ref}?view=${ action.val() }`
            }   
        }
    }
})